import { BuildClass, DateTimeObj } from '../../../../universal';
import { _, React } from '../../../lib';
import { setContextMenu } from '../context-menu';
import { HelpTooltip } from '../help';
import { KebabMenu } from '../kebab';
import { CJSX } from '../meta-types';
import { TextSearched } from '../text';
import { getNoteActions } from './actions';
import { NoteAttachment } from './attachments';
import { editNoteTags } from './edit';
import { generateContent } from './generative';
import { NoteDetailsMultiSelect } from './multiple';
import { getFlattenedTags, TagIndicator } from './tags';
import { ACTION_CONTEXT_MENU_WIDTH } from './types';
export const NoteDetails = (props) => {
    const rs = props.rs;
    const selectedNotes = rs.state.selectedNotes.map(selectedNote => rs.props.notes.find(x => x.ID == selectedNote));
    const selectedNote = selectedNotes[0];
    if (!selectedNote || selectedNotes.length == 0) {
        return (React.createElement("div", { className: "h-full overflow-y-auto px-2 bg-neutral-300 relative" },
            React.createElement("span", { className: BuildClass([
                    'absolute top-1/3 left-1/2 translate-x-[-50%] translate-y-[-50%]',
                    'font-light text-xl text-neutral-600 text-center',
                ]) }, "Select a note")));
    }
    if (selectedNotes.length > 1) {
        return React.createElement(NoteDetailsMultiSelect, { rs: rs, selected: selectedNotes });
    }
    const hasAttachment = Boolean(selectedNote.Attachment?.Checksum);
    const created = DateTimeObj.parse(selectedNote.Created);
    return (React.createElement("div", { className: "relative h-full overflow-y-auto bg-neutral-300 flex flex-col" },
        React.createElement("div", { className: "p-3 font-condensed select-none text-right pr-10" },
            React.createElement(CJSX, { cond: Boolean(selectedNote.CreatedAuthor) },
                React.createElement("span", { className: "text-neutral-600 mr-2" },
                    "Author: ",
                    selectedNote.CreatedAuthor),
                React.createElement("span", { className: "text-neutral-600 inline" }, " \u2022 ")),
            React.createElement("span", { className: "text-neutral-600", title: created.fmtDMY({
                    seconds: true,
                    weekday: true,
                    shortYear: false,
                }) }, created.fmtDMY({ seconds: false, weekday: true, shortYear: true }))),
        React.createElement("div", { className: "absolute right-[5px] top-[5px] w-8 h-8" },
            React.createElement(KebabMenu, { className: {
                    div: [
                        'w-full h-full p-2 rounded-md',
                        'cursor-pointer hover:bg-[hsla(0,0%,0%,0.1)]',
                    ],
                    img: 'w-4 h-4',
                }, preferLeft: true, stopPropagation: true, width: ACTION_CONTEXT_MENU_WIDTH, items: () => getNoteActions(rs, [selectedNote]) })),
        selectedNote.Meta ? (React.createElement("div", { className: BuildClass([
                'p-2 m-1 bg-white',
                'border border-solid border-neutral-400 rounded-md',
                'font-condensed select-none text-center',
            ]) },
            React.createElement(CJSX, { cond: Boolean(selectedNote.Meta.link) },
                React.createElement("a", { className: "text-blue-500 hover:text-red-600 cursor-pointer", title: selectedNote.Meta.text, onClick: e => {
                        e.preventDefault();
                        selectedNote.Meta?.link?.();
                    } },
                    React.createElement(TextSearched, { text: selectedNote.Meta.text, needles: rs.state.searchText, tailwind: true }))),
            React.createElement(CJSX, { cond: !Boolean(selectedNote.Meta.link) },
                React.createElement(TextSearched, { text: selectedNote.Meta.text, needles: rs.state.searchText, tailwind: true })))) : (React.createElement(React.Fragment, null)),
        React.createElement("div", { className: BuildClass({
                'overflow-y-auto': true,
                'min-h-9 max-h-[30%]': hasAttachment,
                'flex flex-col': true,
            }) },
            React.createElement("pre", { className: BuildClass({
                    'p-2 m-1 bg-white': true,
                    'border border-solid border-neutral-400 rounded-md': true,
                    'font-condensed whitespace-pre-wrap select-text': true,
                    'flex-grow': true,
                }), onContextMenu: e => {
                    e.preventDefault();
                    e.stopPropagation();
                    setContextMenu({
                        position: {
                            x: e.clientX,
                            y: e.clientY,
                        },
                        width: ACTION_CONTEXT_MENU_WIDTH,
                        items: () => getNoteActions(rs, [selectedNote]),
                    });
                } },
                React.createElement("h2", { className: BuildClass([
                        'mb-3 pr-6',
                        'font-bold font-condensed text-xl leading-7 text-black',
                    ]) },
                    React.createElement(CJSX, { cond: Boolean(selectedNote.Title) },
                        React.createElement(TextSearched, { text: selectedNote?.Title ?? '', needles: rs.state.searchText, tailwind: true })),
                    React.createElement(CJSX, { cond: !selectedNote.Title },
                        React.createElement("span", { className: "text-neutral-500 font-normal" },
                            "No Title",
                            React.createElement(CJSX, { cond: Boolean(rs.props.editing) &&
                                    !(rs.props.disableGenerativeAI ?? false) },
                                React.createElement(HelpTooltip, { title: "Use generative AI to quickly produce a title based on the note contents" },
                                    React.createElement("button", { className: "ml-2 grayscale hover:grayscale-0", onClick: () => {
                                            generateContent(rs, selectedNote, [
                                                'title',
                                            ]);
                                        } },
                                        React.createElement("img", { src: "/static/img/i8/color-sparkles.svg", className: "w-4 h-4", alt: "Generative AI" }))))))),
                React.createElement(CJSX, { cond: !selectedNote.Note },
                    React.createElement("span", { className: "text-neutral-500" },
                        "No body text",
                        React.createElement(CJSX, { cond: Boolean(rs.props.editing) &&
                                !(rs.props.disableGenerativeAI ?? false) },
                            React.createElement(HelpTooltip, { title: "Use generative AI to quickly produce a note based on the attachment" },
                                React.createElement("button", { className: "ml-2 opacity-70 hover:opacity-100", onClick: () => {
                                        generateContent(rs, selectedNote, ['summary']);
                                    } },
                                    React.createElement("img", { src: "/static/img/i8/color-sparkles.svg", className: "w-4 h-4", alt: "Generative AI" })))))),
                React.createElement(TextSearched, { text: selectedNote?.Note?.trim() ?? '', needles: rs.state.searchText, tailwind: true })),
            React.createElement(TagInfo, { rs: rs, note: selectedNote })),
        React.createElement(CJSX, { cond: hasAttachment },
            React.createElement("div", { className: "flex-1 overflow-y-auto" },
                React.createElement(NoteAttachment, { attachment: selectedNote.Attachment })))));
};
const TagInfo = (props) => {
    const flatTags = getFlattenedTags(props.rs);
    const canUpdate = Boolean(props.rs.props.tagging?.onUpdate);
    return (React.createElement("div", { className: "px-1 my-1 text-right shrink-0" },
        React.createElement("span", { className: BuildClass({
                'inline-block p-1': true,
                'cursor-pointer rounded-md': canUpdate,
                'hover:bg-yellow-100': canUpdate,
                'hover:outline hover:outline-blue-500': canUpdate,
            }), title: canUpdate ? 'Click to edit tags' : undefined, onClick: () => {
                if (canUpdate) {
                    editNoteTags({
                        rs: props.rs,
                        note: props.note,
                    });
                }
            } },
            React.createElement(CJSX, { cond: props.note.Tags.length == 0 },
                React.createElement("span", { className: "text-neutral-500" },
                    "No tags",
                    React.createElement(CJSX, { cond: canUpdate },
                        React.createElement(React.Fragment, null, " - click to add")))),
            _.map(props.note.Tags, x => {
                const tag = flatTags[x];
                return (tag && (React.createElement("div", { className: "inline-block text-neutral-500", key: x },
                    React.createElement(TagIndicator, { tag: tag, includeText: true }))));
            }))));
};
//# sourceMappingURL=details.js.map